export const main = {
  class: 'layout',
  layer: 'Layout',
  extension: 'showHeaderAndFooter'
};

export const header = {
  class: 'layer-header',
  id: 'svg_header',
  selector: '#svg_header',
  rectId: 'svg_header_rect',
  layer: 'HeaderView',
  extension: 'showHeaderView'
};

export const footer = {
  class: 'layer-footer',
  id: 'svg_footer',
  selector: '#svg_footer',
  rectId: 'svg_footer_rect',
  layer: 'FooterView',
  extension: 'showFooterView'
};

export const size = {
  initial: 10,
  min: 0,
  max: 100
};

export const pageNumberingStyle = [
  {
    name: 'numbers',
    label: '1, 2, 3, 4, 5…',
    minValue: 0
  },
  {
    name: 'numbers-with-two-digits',
    label: '01, 02, 03, 04, 05…',
    minValue: 0
  },
  {
    name: 'numbers-with-three-digits',
    label: '001, 002, 003, 004, 005…',
    minValue: 0
  },
  {
    name: 'numbers-with-four-digits',
    label: '0001, 0002, 0003, 0004, 0005…',
    minValue: 0
  },
  {
    name: 'letters',
    label: 'a, b, c, d, e, f',
    minValue: 1
  },
  {
    name: 'capital-letters',
    label: 'A, B, C, D, E, F…',
    minValue: 1
  },
  {
    name: 'roman-numbers-lower',
    label: 'i, ii, iii, iv, v…',
    minValue: 1
  },
  {
    name: 'roman-numbers',
    label: 'I, II, III, IV, V…',
    minValue: 1
  }
];

export const pageNumbering = {
  defaultFontSettings: {
    size: 11,
    family: 'Lato'
  },
  attribute: {
    name: 'data-meta',
    value: 'page-numbering',
    selector: '[data-meta="page-numbering"]'
  }
};

export const heading = {
  defaultFontSettings: {
    size: 11
  },
  textSettings: {
    size: 28
  },
  attribute: {
    name: 'data-meta',
    value: 'page-heading',
    selector: '[data-meta="page-heading"]'
  }
};

export const headingFontSizes = { 1: 26, 2: 22, 3: 19, 4: 16, 5: 14 };

export const headingStyle = {
  is_dark: false,
  color_code: '#000',
  letter_spacing: 0,
  word_spacing: 0
};

export const headings = [
  {
    value: 1,
    label: 'Heading 1'
  },
  {
    value: 2,
    label: 'Heading 2'
  },
  {
    value: 3,
    label: 'Heading 3'
  },
  {
    value: 4,
    label: 'Heading 4'
  },
  {
    value: 5,
    label: 'Heading 5'
  }
];

export const allowedMenuItems = ['images', 'text', 'logos', 'elements'];
